import styled from "styled-components";

export const ObraName = styled.div`
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  width: 100%;
  padding-left: 26px;
  cursor: pointer;

  &:hover > strong {
    text-decoration: underline;
  }

  strong {
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    color: ${({ theme }) => theme.colors.surface.onSurface};

    span {
      color: ${({ theme }) => theme.colors.surface.surface};
      margin-top: 2px;
    }
  }

  span {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-top: 5px;
  }

  .obraNameSemConexao{
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    color: ${({ theme }) => theme.colors.danger.danger};

    span {
      color: ${({ theme }) => theme.colors.danger.onDanger};
      margin-top: 2px;
    }
  }

  .semConexao {
    width: 100px;
    height: 19px;
    padding: 3px;
    line-height: 14px;
    border-radius: 30px;
    text-align:center;
    border-radius: 9.5px;
    background-color: ${({ theme }) => theme.colors.danger.danger};
    color: ${({ theme }) => theme.colors.danger.onDanger};
  }

  .wrapperNameAndBadge {
    display: flex;
    align-items: center;
    
    .name {
      color: #${({ theme }) => theme.colors.surface.onSurface};
      font-size: 22px;
      font-weight: 700;

      div {
        margin-bottom: 5px;
      }

      span, div {
        color: ${({ theme }) => theme.colors.surface.onSurface};
        font-size: 22px;
        font-weight: 700;
      }
    }

    span {
      margin-top: 1px;
    }

    sup {
      margin-left: 18px;
    }
  }
`;

export const ObraAvatar = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 35px;
  margin-top: 25px;
  width: 100%;
  padding: 0 24px;

  > span,
  > button {
    margin-right: 4px;
  }

  .buttomUser {
    height: 28px;
    width: 28px;
    min-width: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant};
    border: ${({ theme }) => theme.colors.secondary.secondaryOutline};
    margin-left: 4px;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.secondary.onSecondaryHover}, ${theme.colors.secondary.secondary})`} !important;
      color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
      border-color: transparent !important;
    }

    label {
      font-size: 23px;
      font-weight: bold;
      position: relative;
      cursor: pointer;
    }
  }

  .buttomListUser {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.primary.primary})`} !important;
    color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
    margin-right: 0 !important;
    margin-left: 4px !important;
    cursor: default !important;
  }

  .opacitySemConexao {
    opacity: 0.25!important;
  }
`;

export const ObraItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.surface};

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`} !important;
  }

  .obraImg {
    margin-top: 25px;
    height: 135px;
    width: 225px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    border-radius: 5px;

    span {
      height: 135px;
      width: 225px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .obraImgDisabled{
    margin-top: 25px;
    height: 135px;
    width: 225px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    overflow: hidden;
    border-radius: 5px;

    span {
      height: 135px;
      width: 225px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ListSharedUsers = styled.div`
  display: flex;
  flex-direction: column;
  
  label {
    padding: 1px 3px;
  }
`;
